import { render, staticRenderFns } from "./current-location-button.vue?vue&type=template&id=06b0b8b5"
import script from "./current-location-button.vue?vue&type=script&lang=js"
export * from "./current-location-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports